import React, { useEffect } from 'react';
import { Button, Form, FormGroup, Label, Input } from 'reactstrap';
import {t} from 'ttag';

const LandingPage = () => {
  useEffect(() => {
    window.location.replace('https://www.jegyezz.hu/');
  }, []);

  return null;
}

export default LandingPage

// export default class LandingPage extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       isOpen: false
//     };
//   }

//   render() {
//     return (
//       <React.Fragment>
//         <div className="expanded landing__section">
//           <div className="container">
//             <div className="cta__inner">
//               <div className="searchbox">
//                 <h2 className="cta__title" style={{ color: '#484848', marginBottom: 16 }}>{ t`Foglaljon helyet!` }</h2>
//                 <Form style={{ marginBottom: 0 }}>
//                   <FormGroup>
//                     <Label for="esemeny">{ t`Esemény` }</Label>
//                     <Input name="esemeny" id="esemeny" />
//                   </FormGroup>
//                   <FormGroup>
//                     <Label for="hely">{ t`Hely` }</Label>
//                     <Input name="hely" id="hely" />
//                   </FormGroup>
//                   <div className="search-button">
//                     <Button className="search-button-style" onClick={() => {}}>{ t`Keresés` }</Button>
//                   </div>
//                 </Form>
//               </div>
//             </div>
//           </div>
//         </div>
//         {/* <div className="expanded landing__section">
//           <div className="container">
//             <div className="expanded__inner">
//               <h2 className="expanded__title">{ t`Legutóbbi események` }</h2>
//             </div>
//           </div>
//         </div>
//         <div className="expanded landing__section">
//           <div className="container">
//             <div className="expanded__inner">
//               <div className="expanded__media">
//                 <img src="#" className="expanded__image" alt="todo" />
//               </div>
//               <div className="expanded__content">
//                 <h2 className="expanded__title">{ t`Ismertető` }</h2>
//                 <p className="expanded__text">{ t`Leirea sad asdas da das das das das das das das das d.` }</p>
//               </div>
//             </div>
//           </div>
//         </div>
//         <div className="steps landing__section">
//           <div className="container">
//             <h2>{ t`Mire használható a Zjegy?` }</h2>
//             <p>{ t`Reméljük megtalálja az önnek legmegfelelőbb felhasználást!` }</p>
//           </div>
//           <div className="container">
//             <div className="steps__inner">
//               <div className="step">
//                 <div className="step__media">
//                   <img src="#" className="step__image" alt="todo" />
//                 </div>
//                 <h4>{ t`Jegyvásárlás` }</h4>
//                 <p className="step__text">{ t`Válassz az események közül és foglalja le vagy vásárolja meg az önnek szimpatikus helyet!` }</p>
//               </div>
//               <div className="step">
//                 <div className="step__media">
//                   <img src="#" className="step__image" alt="todo" />
//                 </div>
//                 <h4>{ t`Jegyeladás` }</h4>
//                 <p className="step__text">{ t`Állitsa össze rendevényét vagy ....` }</p>
//               </div>
//               <div className="step">
//                 <div className="step__media">
//                   <img src="#" className="step__image" alt="todo" />
//                 </div>
//                 <h4>{ t`Tájékozódás` }</h4>
//                 <p className="step__text">{ t`Nézzen körül a weboldalon és ismerje meg milyen programokon vehet részt lakóhelye közelében.` }</p>
//               </div>
//             </div>
//           </div>
//     </div> */}
//       </React.Fragment>
//     );
//   }
// }